import Skeleton from 'react-loading-skeleton'
import styles from '../mobile/styles.module.scss'

const MOCK_NUMBER_OF_STORES = new Array(10).fill(null).map((e, i) => i)
const MOCK_NUMBER_OF_EVENTS = new Array(4).fill(null).map((e, i) => i)

const NavigationItem = () => {
  return (
    <div className={styles.stores__item}>
      <div className={styles.stores__link}>
        <Skeleton height={80} width={80} className={styles.stores__image} />
        <Skeleton className={styles.stores__city} />
      </div>
    </div>
  )
}

const MobileSkeleton = () => {
  return (
    <div className={styles.stores}>
      <Skeleton className={styles.stores__header} />
      <Skeleton className={styles.stores__subheader} />

      <nav className={styles.stores__nav}>
        {MOCK_NUMBER_OF_STORES.map(item => (
          <NavigationItem key={item} />
        ))}
      </nav>

      <section className={styles['stores__details-container']}>
        <Skeleton className={styles['stores__carousel-image']} width="100%" height={300} />

        <section className={styles.store__container}>
          <div className={styles.store_heading}>
            <Skeleton className={styles.store__name} count={2} />
            <Skeleton className={styles.store_distance} />
          </div>

          <div className={styles.store__section}>
            <Skeleton className={styles['store__section-title']} />
          </div>

          <div className={styles.store__section}>
            <Skeleton className={styles['store__section-title']} count={3} />
          </div>

          <div className={styles.store__events}>
            {MOCK_NUMBER_OF_EVENTS.map(item => (
              <Skeleton key={item} className={styles['store__section-title']} />
            ))}
          </div>
        </section>
      </section>
    </div>
  )
}

export default MobileSkeleton
